<template>
  <div
    :class="{
      'vogue-am':
        card_animate == 'vogue-am' ||
        (theme == 'vogue' && card_animate == 'default'),
      'card-box-sizing': theme == 'athena',
      'athena-product-card': theme == 'athena',
    }"
    style="width: 100%"
  >
    <a
      v-if="product_res"
      class="columns"
      :href="
        variant_src_id
          ? `${product_res.path}?variant=${variant_src_id}` ||
            `${product_res.public_url}?variant=${variant_src_id}`
          : product_res.path || product_res.public_url
      "
      :title="product_res.post_title || product_res.title"
    >
      <div
        class="product_item"
        :class="{
          p_list_2: !filter_onoff && product_list_layout === '2columns',
          p_list_3:
            (!filter_onoff && product_list_layout === '3columns') ||
            (filter_onoff && product_list_layout === '2columns'),
          p_list_4:
            (!filter_onoff && product_list_layout === '4columns') ||
            (filter_onoff && product_list_layout === '3columns'),
          p_list_5: filter_onoff && product_list_layout === '4columns',
        }"
      >
        <div class="product_media">
          <div
            :class="[
              theme == 'venue' && card_radio == 'vertical'
                ? 'vertical2'
                : card_radio || 'square',
            ]"
            class="product_media_img"
            :style="{ backgroundColor: img_backgorund}"
          >
            <template>
              <v-lazy-img
                :class="[
                  'img-fluid',
                  {
                    'product_media_img_first':
                      card_animate == 'show_second_img' && product_res.gallery && product_res.gallery[1],
                    'img-cover': config.card_img_style === 'cover',
                  },
                ]"
                :dataUrl="mainImg.url || (mix_now_image_data && mix_now_image_data.url)"
                :alt="product_res.post_title"
                @load.once="load && load()"
              ></v-lazy-img>
              <v-lazy-img
                :class="[
                    'product_media_img_hover',
                    {
                      'img-cover': config.card_img_style === 'cover',
                    },
                ]"
                v-if="
                  card_animate == 'show_second_img' &&
                  product_res.gallery &&
                  product_res.gallery[1]
                "
                :dataUrl="product_res.gallery[1].url"
                @load.once="load && load()"
              ></v-lazy-img>

            </template>
            <v-custom-button
              v-if="custom_button && custom_button.is_card == '1'"
              model="is_card"
              :custom_button="custom_button"
            ></v-custom-button>
            <v-product-tag
              v-if="$store.state.product_tag_list[product_res.ID]"
              :productTag="$store.state.product_tag_list[product_res.ID]"
              :productInfo="product_info"
            ></v-product-tag>
          </div>
          <v-discount-tag
            v-if="
              !mix_all_disable &&
              show_discount_tag &&
              1 - now_variant.price / now_variant.regular_price > 0.01
            "
            :variants="now_variant"
            :discount_label_color="discount_label_color"
          />
          <!-- 销售标签 -->
          <template>
            <div
              v-if="
                theme == 'athena' &&
                !mix_all_disable &&
                computed_price.agio > 0 &&
                sale_image_show
              "
              class="vogue_sales_label"
              :style="{
                background: `url(${
                  sale_image ? sale_image : '@/images/vogue-sale.png'
                })`,
              }"
            >
              <div class="item">
                <p>{{ computed_price.percentage }}%</p>
                <p>OFF</p>
              </div>
            </div>
            <v-sales-label v-if="theme == 'vogue' && !mix_all_disable && computed_price.agio > 0 && sale_image_show"  :price="computed_price" :config="config"></v-sales-label>
            <div
              v-if="
                theme == 'venue' &&
                !mix_all_disable &&
                computed_price.agio > 0
              "
              class="product_label venue_sales_label title_font2"
            >
              <p class="product_label_text secondary_title">
                {{ $t("venue.productList.on_sale") }}
              </p>
            </div>
            <div
              v-if="mix_all_disable"
              class="product_label venue_sales_label title_font2"
            >
              <p class="product_label_text secondary_title text-uppercase">
                {{ $t("venue.productList.sold_out") }}
              </p>
            </div>
          </template>

          <!-- 购买按钮, 雅典娜主题不显示；如果设置了隐藏；如果该商品仍可售卖 -->
          <template v-if="theme !== 'athena' &&
            buy_button_style &&
            buy_button_style !== 'none' &&
            !mix_all_disable
          ">
            <!-- 直接添加到购物车， 不存在变种的时候 -->
            <!-- 自定义按钮： 只有单个商品，且隐藏按钮，则隐藏 -->
            <button
              v-if="
                product_res.variants_detail &&
                product_res.variants_detail.length <= 1
              "
              :disabled="disabled"
              v-show="!(custom_button && custom_button.is_cart_card === 1)"
              :productDetail="JSON.stringify(product_res)"
              class="addcart main_button secondary_title"
              :class="{
                'addcart_always': buy_button_style === 'always',
                'addcart_hover': buy_button_style !== 'always'
              }"
              @click="handleClick"
            >
              <template v-if="config.buy_button_text !== undefined ">
                {{ config.buy_button_text || 'SELECT OPTION' }}
              </template>
              <template v-else>
                {{ `${$t("venue.productList.add_to_cart")} +`}}
              </template>
            </button>

            <!-- 选择select， 存在多个变种的时候 -->
            <button
              v-if="
                product_res.variants_detail &&
                product_res.variants_detail.length > 1
              "
              :disabled="disabled"
              class="addcart main_button secondary_title"
              :class="{
                'addcart_always': buy_button_style === 'always',
                'addcart_hover': buy_button_style !== 'always'
              }"
              @click="handleClick"
            >
              <template v-if="config.buy_button_text !== undefined ">
                {{ config.buy_button_text || 'SELECT OPTION' }}
              </template>
              <template v-else>
                {{ $t("venue.productList.selected_options") }} >
              </template>
            </button>
          </template>
        </div>
        <div
          class="product_details"
          :style="{ textAlign: text_align || 'center' }"
        >
          <h3
            v-if="config.card_title_style !== 0 && (show_name == null || show_name == true)"
            class="product_title h4 page_text_font"
            :style="{ fontSize: font_size ? font_size + 'px' : '14px', '-webkit-line-clamp':config.card_title_style }"
          >
            {{ product_res.post_title || product_res.title }}
          </h3>
          <h5
            v-if="
              theme == 'athena' &&
              (show_name == null || show_name == true)
            "
            class="product_subtitle"
          >
            {{ product_res.subtitle }}
          </h5>
          <!-- 产品调色板 -->
          <v-product-palette
            type="card"
            v-if="
              palette_config && variant.length &&
              ((product_res.product_palette &&
                product_res.product_palette.length) ||
                ($store.state.product_palette_list[product_res.ID] &&
                  $store.state.product_palette_list[product_res.ID].length))
            "
            :palette_attrs="[
              product_res.product_palette
                ? product_res.product_palette[0]
                : $store.state.product_palette_list[product_res.ID][0],
            ]"
            :variant_attrs="variant"
            :palette_config="palette_config"
            :mouse_enter="false"
            :url="product_res.path || product_res.public_url"
            :keys="keys"
            :theme="theme"
          ></v-product-palette>
          <div
            v-if="
              (show_star == null || show_star == true || show_star == 'only') &&
              $store.state.plugConfig.Comment &&
              !product_list_layout &&
              theme != 'athena'
            "
            :style="{'visibility':!(show_star === 'only' && Number(product_res.review_count) === 0) && product_res.review_status=='open'?'visible':'hidden'}"
          >
            <v-star
              :disabled="true"
              :average_rating="
                product_res.average_rating
                  ? product_res.average_rating
                  : '0'
              "
              :font_size="16"
            ></v-star>
            ({{
              product_res.review_count ? product_res.review_count : "0"
            }})
          </div>

          <p
            v-if="show_product_price == null || show_product_price == true"
            class="athena_price"
            :class="product_price === 'hover' ? 'product_details_hover' : ''"
          >
            <v-selectprice
              v-if="!mix_all_disable || theme == 'vogue' || theme == 'athena'"
              :price="computed_price.price"
              :font-size="show_currency_selector ? 16 : 20"
              :regular-font-size="show_currency_selector ? 14 : 17"
              :regular_price_num="
                computed_price.regular_price > computed_price.price &&
                computed_price.regular_price
              "
              :disable_select="disable_select"
              :country="!show_currency_selector ? '' : $store.state.pricetype"
            ></v-selectprice>
          </p>
          <div
            v-if="
              $store.state.plugConfig.Comment &&
              show_star &&
              (product_list_layout || theme == 'athena')
            "
            class="ahtena_star"
            :style="{'visibility':!(show_star === 'only' && Number(product_res.review_count) === 0) && product_res.review_status=='open'?'visible':'hidden'}"
          >
            <v-star
              :disabled="true"
              :average_rating="
                product_res.average_rating
                  ? product_res.average_rating
                  : '0'
              "
              :font_size="16"
            ></v-star>
            <span class="ahtena_star-num">
              ({{ product_res.review_count || "0" }})
            </span>
          </div>
          <p
            v-if="theme == 'venue' && mix_all_disable"
            class="sold_out secondary_title"
          >
            {{ $t("venue.productList.sold_out") }}
          </p>
          <div
            :class="{
              combination_card:
                theme == 'athena' &&
                $store.state.combination_list &&
                $store.state.combination_list[combination_position] &&
                !$store.state.combination_list[combination_position][product_res.ID],
            }"
            v-if="theme == 'athena'"
          >
            <v-custom-swiper
              :total_num="
                $store.state.combination_list[combination_position] &&
                $store.state.combination_list[combination_position][product_res.ID] &&
                $store.state.combination_list[combination_position][product_res.ID].items &&
                Object.keys(
                  $store.state.combination_list[combination_position][product_res.ID].items
                ).length
              "
              :page_num="page_size || aabb()"
              button_type="label_button"
              v-if="$store.state.combination_list[combination_position] && $store.state.combination_list[combination_position][product_res.ID]"
              :not_swiper="screenWidth < 768"
            >
              <v-combination-card
                v-if="$store.state.combination_list[combination_position] && $store.state.combination_list[combination_position][product_res.ID]"
                :combinations="$store.state.combination_list[combination_position][product_res.ID]"
                :theme="theme"
                :productDetail.sync="product"
              ></v-combination-card>
            </v-custom-swiper>
          </div>
          <div
            v-if="theme == 'athena' && show_add_card_btn !== false && buy_button_style !== 'none'"
            :class="{
              addcart_hover: buy_button_style !== 'always',
            }"
          >
            <v-add-card-btn
              :theme="theme"
              :cart_type="cart_type"
              :product_res="product_res"
              :variant_attrs="variant"
              :computed_price="computed_price"
              @showMobileAddCartPopup="showMobileAddCartPopup(product_res)"
              @clickAdd="add_cart()"
            ></v-add-card-btn>
          </div>
        </div>
      </div>
    </a>

    <!-- 弹窗加购, 产品卡片->开启加购弹窗 才起作用 -->
    <template v-if="config.buy_button_type === 'popup'">
      <add-cart-dialog
        :visible="dialogVisible"
        :data="productDetail"
        :computedPrice="computed_price"
        :palette-config="palette_config"
        :default-attrs="variant"
        @close="handleDialogClose"
        @added="handleAdded"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixAdd from "@/js/mixins/mixAdd";
import mixProduct from "@/js/mixins/mixProduct";
import mixProductTag from "@/js/mixins/mixProductTag";
import AddCartDialog from '@/js/components/AddCartDialog.vue';
import vSalesLabel from './salesLabel.vue'
import vStar from "@/js/components/view/comments/commentsstar";
import vProductPalette from "@/js/components/view/productpalette/index";
import vAddCardBtn from "@/js/components/common/addCardBtn.vue";
import vCombinationCard from "@/js/components/view/combinations/combinationCard.vue";
import vCustomSwiper from "@/js/components/common/customSwiper.vue";
import vDiscountTag from "@/js/components/common/discountTag.vue";
import vProductTag from '@/js/components/view/productTag/productTag.vue'

export default {
  props: {
    productDetail:{},
    cart_type:{},
    show_currency_selector:{},
    layout:{},
    theme:{},
    card_animate:{}, // 滑动显示第二张产品图片
    // buy_button_style:{}, // 改用vuex中数据 快捷购买按钮
    text_align:{}, // 文字居中，靠左
    product_price:{}, // 商品价格
    card_radio:{}, // 卡片形状
    sales_label:{}, // 销售标签
    disable_select:{}, // 是否开启货币选择
    sale_image:{},
    show_star_abd:{}, //根据历史浏览配置显示产品评星
    sale_image_show:{},
    font_size:{},
    custom_button:{}, //自定义按钮配置
    model:{}, //自定义按钮模式
    // product_palette:{},
    palette_config:{},
    keys:{},
    product_list_layout:{},
    filter_onoff:{},
    load:{},
    comment:{},
    show_add_card_btn:{}, //athena加购按钮在历史浏览插件中干掉为false
    show_discount_tag:{}, //展示历史浏览记录折扣标签
    discount_label_color:{}, //折扣标签图片的颜色跟随主按钮背景颜色
    show_name:{}, // 根据历史浏览配置显示产品名
    show_product_price:{}, //根据历史浏览配置显示产品价格
    combination_position:{}, //款式组合位置
    isShowMainImg:{}, // 产品卡片展示主图
    addType:{
      default:"card"
    }, // 加购类型 (guessLike||BrowsingRecord 默认card)
  },
  mixins: [mixAdd, mixProduct, mixProductTag],
  data() {
    return {
      // defaultImage,
      price: 0,
      regularPrice: 0,
      stock: true,
      cardStyle: {},
      disabled: false,
      selected_variant: [],
      palette_img: "",
      variant_src_id: null,
      productImageData: this.product_res?.gallery?.[0] || {},
      product: {},
      product_res: {},
      now_variant: {},
      add_cart_data: {
        product_id: null,
        quantity: 1,
      },
      page_size: 0,
      dialogVisible: false
    };
  },
  methods: {
    /**
     * 点击按钮
     * 1、根据按钮配置
     * - popup 打开弹窗
     * - link 跳转到详情页
     * - add 直接添加到购物车
     * 2、兼容旧数据
     * - 如果没有按钮相关配置
     * - 大于1个变种，跳转到详情页
     * - 没有变种或只有一个变种时，直接加购
     */
    handleClick(event) {
      if (event?.preventDefault) event.preventDefault();

      // 按钮配置
      const buyButtonType = this.config.buy_button_type || undefined;

      // 如果没有相关配置时，需要兼容旧数据
      if (buyButtonType === undefined) {
        // 如果存在多个变种，跳转到详情页
        const variantsDetail = this.product_res?.variants_detail || [];
        if (variantsDetail.length > 1) {
          window.open(this.product_res.public_url, "_self");
        } else {
          // 直接添加到购物车
          this.addToCart();
        }

        return
      }

      // 如果弹窗
      if (buyButtonType === 'popup') {
        this.dialogVisible = true
        // return
      }

      // 如果配置是直接进入详情页
      else if (buyButtonType === 'link') {
        window.open(this.product_res.public_url, "_self");
        // return
      }

      // 直接添加到购物车
      else if (buyButtonType === 'add') {
        this.addToCart()
      }
    },

    // 添加到购物车
    async addToCart() {
      const variantsDetail = this.product_res?.variants_detail || [];

      // 如果是直接添加到购物车
      const addCartData = {
        addType: this.addType,
        product_id: this.product_res.ID,
        quantity: 1,
      };

      // 多个商品，直接购物第一个变种
      if (variantsDetail.length > 0) {
        addCartData.variant_id = variantsDetail[0]?.ID || undefined;
      }

      const { dispatch } = this.$store

      try {
        this.disabled = true;
        // 修改禁用按钮
        dispatch("change_button_disabled", true);
        // const res = await this.$axios.post(API.addcart, addCartData);

        const res = await dispatch({
          type: 'product/addToCart',
          payload: {
            data: addCartData,
            productDetail: this.product_res
          }
        })

        this.disabled = false;
        // 打开购物车
        this.openTheCart(res)
      } catch (error) {
        this.disabled = false;
        dispatch("change_button_disabled", false);

        const { response } = error
        if ( response?.data?.errors ) {
          this.$message.error(Object.values(response.data.errors)?.[0]?.[0]);
        } else {
          this.$message.error(response?.data?.message);
        }
      }
    },
    combineSize() {
      let combineWidth = this.screenWidth > 768 ? 67 : 50;
      if (this.$("div.combine").length > 0) {
        // this.screenWidth = this.$(window).width();
        let nexSize = this.$("div.product_details").width() / combineWidth;
        if (this.page_size != nexSize) {
          this.page_size = nexSize;
        }
      }
    },
    aabb() {
      let combineWidth = this.screenWidth > 768 ? 67 : 50;
      return this.$("div.product_details").width() / combineWidth;
    },

    /**
     * 打开购物车
     * TODO: 错误的是实现，禁止用JS去控制购物车打开，待修改
     */
    openTheCart(res) {
      const { data, status } = res
      const { dispatch } = this.$store

      // TODO: 这些事件应统一挪到store中处理
        // TODO: 这些事件应统一挪到store中处理
      // TODO: 这些事件应统一挪到store中处理
      dispatch("change_news_cart", data);
      dispatch("cartContentsCount", data.cart_contents_count);
      localStorage.setItem("cartContentsCount", data.cart_contents_count);

      // 打开购物车
      if (
        (this.theme == "venue" || this.theme == "showtime") &&
        this.cart_type == "popup"
      ) {
        this.$("#modalCart").modal("show");
      } else if (
        this.theme == "vogue" &&
        (this.cart_type == "drawer" || this.cart_type == "popup")
      ) {
        this.showInlineCart();
      } else {
        window.open("/cart", "_self");
        setTimeout(() => {
          this.$store.dispatch("change_button_disabled", false);
        }, 5000);
      }
    },

    // 关闭快捷加购弹窗
    handleDialogClose() {
      this.dialogVisible = false
    },
    // 添加成功
    handleAdded(res) {
      // 关闭弹窗
      this.dialogVisible = false
      // 打开购物车
      this.openTheCart(res)
    }
  },
  beforeMount() {
    this.product = this.productDetail;
  },
  mounted() {
    this.combineSize();
    window.addEventListener("resize", () => {
      this.combineSize();
    });
  },
  computed: {
    mainImg() {
      if (this.isShowMainImg && !this.palette_config) {
        return this.product_res?.gallery?.[0] || {}
      }

      return {}
    },
    ...mapState({
      img_backgorund: ({ options }) => options?.theme?.global?.colors?.img_backgorund || '#ffffff',
      // 产品卡片配置
      config: ({ options }) => options?.theme?.global?.product_cart || {},
      show_star: ({ options }) => options?.theme?.global?.product_cart?.show_star,
      buy_button_style: ({ options }) => options?.theme?.global?.product_cart?.buy_button_style,
      screenWidth: ({ screenWidth }) => screenWidth
    }),
    // computed_price: function() {
    //   return {price:Number(this.price), regular_price:Number(this.regularPrice)}
    // }
  },
  components: {
    vStar,
    vProductPalette,
    vAddCardBtn,
    vCombinationCard,
    vCustomSwiper,
    vDiscountTag,
    vProductTag,
    AddCartDialog,
    vSalesLabel,
  },
};
</script>

<style scoped lang='scss'>
.columns {
  .product_media_img {
    width: 100%;
    padding-top: 100%;
    position: relative;

    .img-fluid {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain !important;
      backface-visibility: hidden;
      transition: all 0.3s ease-in-out;
    }

    .product_media_img_hover {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      object-fit: contain !important;
      opacity: 0;
      visibility: hidden;
      transition: all 0.2s ease-in;
    }

    .img-cover {
      object-fit: cover !important;
    }

  }
  .square {
    padding-top: 100% !important;
  }

  .horizon {
    padding-top: 75% !important;
  }

  .vertical {
    padding-top: 133% !important;
  }

  .vertical2 {
    padding-top: 150% !important;
  }
  .auto {
    padding-top: unset !important;
    .img-fluid {
      position: relative !important;
      display: block;
    }
  }
}
a {
  .product_item {
    width: 100%;
    margin-bottom: 20px;
    break-inside: avoid;
    .product_media {
      width: 100%;
      box-sizing: inherit;
      position: relative;
      min-height: 100px;

      .addcart {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
        background-color: black;
        color: white;
        height: 32px;
        position: absolute;
        bottom: 0px;
        font-size: 12px;
        opacity: 0.8;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
      }

      .addcart_hover {
        display: none;
      }

      .addcart_always {
        display: block;
      }

      .addcart_none {
        display: none;
      }

      .product_label {
        position: absolute;
        background: #d34a4a;
        top: 12px;
        right: -6px;
        padding: 6px 18px;
        z-index: 1;

        .product_label_text {
          line-height: 26px;
          color: #fff;
          font-family: "oswald", sans-serif;
          letter-spacing: 1px;
          font-size: 13px;
          font-weight: 400;
          margin: 0;
        }
      }
      .vogue_sales_label {
        position: absolute;
        right: 0;
        top: 0;
        width: 66px;
        height: 66px;
        z-index: 10;
        transform: scale(0.9);
        background-size: cover !important;
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        .item {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          transform: translate(-50%, -50%);
        }
        p {
          margin: 0;
          text-align: center !important;
        }
        p:nth-last-child(1) {
          font-size: 12px;
        }
      }
    }

    .product_details {
      text-align: center;
      margin-top: 12px;
      padding-bottom: 10px;
      .sold_out {
        font-size: 14px;
        color: #1e0909;
      }

      .product_title {
        margin: 0;
        font-size: 14px;
        line-height: 1.8;
        // text-transform: uppercase;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
      }
      .product_subtitle {
        font-size: 18px;
        margin-top: 13px;
        white-space: nowrap;
        line-height: 23px;
        height: 23px;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-weight: 400;
        color: #888888;
      }

      p {
        // margin-top: 6px;
        margin-bottom: 0px;

        .product_price_price {
          font-family: "oswald", sans-serif;
          line-height: 1;
          font-size: 1rem;
          margin-top: 6px;
        }

        .product_price_cross {
          font-family: "oswald", sans-serif;
          position: relative;
          margin-left: 6px;
          text-decoration: line-through;
          font-size: 0.9em;
          color: #b89797;
          font-size: 1rem;
        }
      }
      .addcart_hover {
        display: none;
      }
      &:hover{
        .addcart_hover{
          display: block;
        }
      }
    }

    .product_details_hover {
      display: none;
      // height: 0;
    }
  }

  .product_item:hover {
    .product_details {
      .product_title {
        opacity: 0.7;
      }
    }

    .product_details_hover {
      display: block;
      transition: all 0.5s;
    }
  }
  .product_item {
    .product_media:hover {
      .addcart_hover {
        display: block;
      }
      .product_media_img {
        .product_media_img_first {
          opacity: 0;
        }

        .product_media_img_hover {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
}
.card-box-sizing {
  box-shadow: 0px 2px 10px 0px rgba(108, 108, 108, 0.24);
  margin-bottom: 10px;
}
.athena-product-card {
  .columns {
    .product_item {
      margin-bottom: 30px;
      .product_details {
        padding-top: 4px;
        padding-left: 20px;
        padding-right: 20px;
        .product_title {
          font-size: 20px !important;
          min-height: 44px;
          line-height: 1.1;
          font-family: Roboto;
          font-weight: 500;
          color: #222222;
        }
        .athena_price{
          min-height: 34px;
        }
        &::v-deep .selectpricewrap {
          margin-top: 10px;
          .product_price_cross {
            line-height: 1;
          }
          .money {
            font-size: 20px !important;
          }
        }
        .variant_attrs_box {
          margin-top: 15px;
        }
        .ahtena_star {
          margin-top: 10px;
          &::v-deep .starWrap {
            font-size: 24px;
            .el-rate {
              height: auto;
              margin-right: 5px;
              .el-rate__icon,
              .el-icon-star-on {
                color: black !important;
                font-size: 29px !important;
              }
              &__decimal {
                color: #000000 !important;
              }
            }
          }
          &-num {
            font-size: 20px;
          }
        }
      }
    }
  }
}
.combination_card {
  height: 85px;
}
@media screen and (max-width: 768px) {
  .combination_card {
    height: 71px;
  }
}
@media screen and (max-width: 575px) {
  .athena-product-card {
    .columns {
      .product_item {
        .product_details {
          margin-top: 8px;
          padding-top: 0;
          padding-left: 10px;
          padding-right: 10px;
          .product_title {
            font-size: 13px !important;
            line-height: 1.1;
            min-height: 27px;
            font-family: Roboto;
            font-weight: 500;
            color: #222222;
            text-align: center;
          }
          .product_subtitle {
            font-size: 12px;
            margin-top: 5px;
            text-align: center;
          }
          &::v-deep .selectpricewrap {
            margin-top: 0;
            .product_price_cross {
              line-height: 1;
            }
            .money {
              font-size: 12px !important;
            }
          }
          .variant_attrs_box {
            margin-top: 15px;
          }
          .athena_price {
            min-height: 24px;
            text-align: center;
          }
          .ahtena_star {
            margin-top: 0;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            &::v-deep .starWrap {
              .el-rate {
                .el-rate__icon,
                .el-icon-star-on {
                  font-size: 14px !important;
                }
              }
            }
            .ahtena_star-num {
              font-size: 12px;
              zoom: 0.83;
              margin-top: 5px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .product_item {
    .product_details_hover {
      display: block !important;
      // height: auto !important;
    }
    .addcart_hover {
      display: block !important;
    }
    .product_label {
      padding: 2px 6px !important;
      .product_label_text {
        font-size: 12px !important;
      }
    }
    .vogue_sales_label {
      width: 50px !important;
      height: 50px !important;
      font-size: 12px !important;
    }
  }
  .product_item {
    margin-bottom: 15px !important;
  }
}
</style>
